<template>
  <div class="top-title-com">
    <div class="top-title">
      <img :src="titleImg[num]" alt="" />
      <div class="title-name">
        <div class="title-name-cn">{{ cnName }}</div>
        <div class="title-name-en">{{ enName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import title01 from '@/assets/title01.png'
import title02 from '@/assets/title02.png'
import title03 from '@/assets/title03.png'
import title04 from '@/assets/title04.png'
export default {
  props: {
    num: {
      type: String,
      required: true,
      default: ''
    },
    cnName: {
      type: String,
      required: true,
      default: ''
    },
    enName: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      titleImg: {
        '01': title01,
        '02': title02,
        '03': title03,
        '04': title04
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top-title-com {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 53px;
  .top-title {
    display: flex;
    align-items: center;
    .title-name {
      margin-left: 8px;
      .title-name-cn {
        margin-top: 20px;
        font-size: 32px;
        color: #333333;
        font-weight: bold;
        line-height: 48px;
      }
      .title-name-en {
        font-family: Helvetica-Light;
        white-space: nowrap;
        font-size: 16px;
        color: #999999;
        line-height: 28px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top-title.vue